"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.StyledSectionButton = exports.Image = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const Typography_1 = require("../Typography");
const StyledSectionButton = styled_components_1.default.button `
  background-color: ${(props) => (props.$isActive ? colors_1.blue : colors_1.white)};
  border-radius: 1rem;
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.6rem;
  height: 4.2rem;
  border: none;

  ${(props) => props.$isNotTimelapseButton &&
    `opacity: 0.7;
    pointer-events: none;`}

  ${(props) => props.$isDisabled &&
    `opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;`}

  @media (min-width: 390px) {
    padding: 0;
  }
`;
exports.StyledSectionButton = StyledSectionButton;
const Title = (0, styled_components_1.default)(Typography_1.H6) `
  text-transform: capitalize;
  ${(props) => props.$isActive && `color: ${colors_1.white};`}
`;
exports.Title = Title;
const Image = styled_components_1.default.img `
  width: 1.2rem;
  height: 1.2rem;
  margin-bottom: 0.25rem;
  ${(props) => props.$isActive &&
    `filter: invert(100%) sepia(37%) saturate(2%) hue-rotate(273deg) brightness(109%) contrast(101%);;`}
`;
exports.Image = Image;
